/**
 * 腾讯云 IM 配置
 *
 * 配置说明：
 * - IM_SDK_APP_ID 从环境变量读取，请在 .env 文件中配置
 *
 * 用户映射关系：
 * - admin 账号（管理员）或 user_type === 'admin' → test1
 * - 医生账号（user_type === 'doctor' 或 'user'）或包含"医生"关键字 → test2
 *
 * 映射逻辑：
 * 1. 优先根据 user_type 判断
 * 2. 其次根据用户名判断
 * 3. 如果用户名包含"医生"关键字，也映射到 test2
 */

export interface IMUserConfig {
  userID: string;
  userSig: string;
  nick?: string;
  role?: string; // 角色说明
}

// IM SDK 应用 ID - 从环境变量读取
export const IM_SDK_APP_ID = Number(process.env.IM_SDK_APP_ID) || 0;

// 测试用户配置
export const IM_TEST_USERS: Record<string, IMUserConfig> = {
  test1: {
    userID: 'test1',
    userSig:
      'eJwtzD0PgjAUheH-0tngbelHQuKiLkSCg4TJRdMrXFFToRDU*N9FYDzPSd4Py5JD0GHNIiYCYItxk8WHpwuN7LHxfD4aW52cI8sirgE4D0Ga6cHeUY2DK6UEAEzq6f43oyVILqScK1QMXb2NRaJueZeur0n4tjbGapNnTaFjdVy6XftqsX*ey71J5Yp9fz8RMag_',
    nick: '测试用户1',
    role: '管理员 (对应 admin 账号)',
  },
  test2: {
    userID: 'test2',
    userSig:
      'eJwtzMEKgkAUheF3mXXYveM4htDKAikLohEj2hSOdonSdFAxevdMXZ7vwP9hKjxatS6Zx7gFbDZsSvTLUEoDG10ZPh1V8rgWBSXMQwmAaINwx0e3BZW6d8dxOACMauj5N1cKEGgjThXK*m4n35Hh68VlvuNmJXDfbOM22ARZes6bQ*jfulNQR766xypfsu8PPjAxpA__',
    nick: '测试用户2',
    role: '医生 (对应 doctor_test 账号)',
  },
};

// 当前使用的测试用户（可以切换）
export const CURRENT_TEST_USER = IM_TEST_USERS.test1;

// 开发环境配置
export const IM_DEV_CONFIG = {
  sdkAppID: IM_SDK_APP_ID,
  userID: CURRENT_TEST_USER.userID,
  userSig: CURRENT_TEST_USER.userSig,
};
